import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useParams,
} from "react-router-dom";
import { useUiTheme } from "../entities/ui-prefs";
import {
  TransactionListPage,
  MonthlySummaryPage,
  DailyRevenuePage,
  StoreRevenuePage,
  BankHistoryPage,
  PlanListPage,
  PlanDetailPage,
  InterestPeriodsPage,
  BankConfigPage,
  StoreCashQrPage,
  CashDepositsPage,
  MappingPage,
  AuditLogPage,
  EmployeeListPage,
  EmployeeDetailPage,
  AccountListPage,
  RoleListPage,
  UserPermissionPage,
  MohReportPage,
  MohValuePage,
  BestsellerPage,
  ProductAnalyticsPage,
  CustomerAnalyticsPage,
  ProductionDashboardPage,
  ProductionDetailPage,
  KeHoachHangHoaPage,
  TargetCategoryPage,
  RestockPage,
  SalesPivotPage,
  MonthlyReportPage,
  MonthlyProductPage,
  BillListPage,
  ProductConfigPage,
  ProductRecodePage,
  FirstSalePage,
  ProductionLarkPage,
  ChinaOrderPage,
  AllocationPage,
  ShopeeAllocPage,
  ImportAllocPage,
  ImportReceiptsPage,
  TargetV3Page,
  MtTransferPage,
  BagLookupPage,
  NhanhvnEntry,
  ShiftCalendarPage,
  ProfilePage,
  UiSettingsPage,
  FacebookPage,
  CskhDashboardPage,
  CskhKpiPage,
  CskhOperationsPage,
  ThhtListPage,
  ThhtDashboardPage,
  ThhtReportPage,
  KolKocListPage,
  KolCampaignListPage,
  KolCampaignDetailPage,
  KolReportKocPage,
  KolReportDailyPage,
  KolReportLatePostPage,
  KolReportCostPage,
  KolReportVideoPage,
  KolReportAllVideosPage,
  KolProvinceSummaryPage,
  KolCampaignPerformancePage,
  AdminIndexPage,
  AdminModelPage,
  AdminRowPage,
  ShippingWeightPage,
  VoucherCampaignDetailPage,
  VoucherPage,
  VoucherPublicPage,
  VoucherPublicResultPage,
  TiktokPage,
  TmdtHomePage,
  LoginPage,
  PortalPage,
  ForbiddenPage,
  LogoutPage,
} from "./lazy-pages";
import { ModuleLayout } from "../widgets/module-layout";
import { RequirePermission } from "./RequirePermission";
import {
  CLEANING_STANDALONE_RE,
  CleaningStandalone,
  cleaningRoutes,
} from "../pages/cleaning";

/** Giữ bookmark/đường dẫn Django cũ hoạt động sau khi cắt cả `/nhanhvn`. */
const LEGACY_NHANHVN_ROUTES: Readonly<Record<string, string>> = {
  "/nhanhvn/bao-cao/ban-hang": "/nhanhvn/ban-hang",
  "/nhanhvn/bao-cao/don-hang": "/nhanhvn/don-hang",
  "/nhanhvn/bao-cao/theo-thang": "/nhanhvn/theo-thang",
  "/nhanhvn/bao-cao/chi-tiet-san-pham": "/nhanhvn/chi-tiet-sp",
  "/nhanhvn/bao-cao/cau-hinh-san-pham": "/nhanhvn/cau-hinh-sp",
  "/nhanhvn/bao-cao/danh-sach-bill": "/nhanhvn/danh-sach-bill",
  "/nhanhvn/bao-cao/phan-tich-san-pham": "/nhanhvn/phan-tich-sp",
  "/nhanhvn/bao-cao/phan-tich-khach-hang": "/nhanhvn/phan-tich-kh",
  "/nhanhvn/bao-cao/ban-chay-ban-cham": "/nhanhvn/ban-chay",
  "/nhanhvn/bao-cao/dashboard-hang-hoa": "/nhanhvn/dashboard-hang-hoa",
  "/nhanhvn/bao-cao/moh": "/nhanhvn/moh",
  "/nhanhvn/bao-cao/moh-gia-tri": "/nhanhvn/moh-gia-tri",
  "/nhanhvn/bao-cao/chia-hang": "/nhanhvn/chia-hang",
  "/nhanhvn/bao-cao/chia-hang-shopee-dt": "/nhanhvn/chia-hang-dt",
  "/nhanhvn/bao-cao/chia-hang-nhap": "/nhanhvn/chia-hang-nhap",
  "/nhanhvn/bao-cao/phieu-nhap-ncc": "/nhanhvn/phieu-nhap",
  "/nhanhvn/bao-cao/chia-hang-kho-mt": "/nhanhvn/chia-kho-mt",
  "/nhanhvn/bao-cao/chia-hang-kho-cua-hang": "/nhanhvn/chia-kho-cua-hang",
  "/nhanhvn/bao-cao/theo-doi-san-xuat": "/nhanhvn/theo-doi-sx",
  "/nhanhvn/bao-cao/dat-hang-trung-quoc": "/nhanhvn/dat-hang-tq",
  "/nhanhvn/bao-cao/san-luong-san-xuat": "/nhanhvn/san-luong-sx",
  "/nhanhvn/bao-cao/bu-hang": "/nhanhvn/bu-hang",
  "/nhanhvn/san-pham/tai-ma": "/nhanhvn/tai-ma",
  "/nhanhvn/san-pham/ngay-ban-dau-tien": "/nhanhvn/ngay-ban-dau-tien",
  "/nhanhvn/target/v3": "/nhanhvn/target-v3",
  "/nhanhvn/target/danh-muc": "/nhanhvn/target-danh-muc",
};

/** Cac bookmark bao cao KOL cu khong can crawler duoc dua sang trang React moi. */
const LEGACY_KOL_ROUTES: Readonly<Record<string, string>> = {
  "/kol/koc": "/kol/danh-sach-koc",
  "/kol/campaigns": "/kol/chien-dich",
  "/kol/reports/koc": "/kol/bao-cao/koc",
  "/kol/reports/koc-daily": "/kol/bao-cao/koc-theo-ngay",
  "/kol/reports/late-post": "/kol/bao-cao/dang-muon",
  "/kol/reports/cost": "/kol/bao-cao/chi-phi",
  "/kol/reports/video": "/kol/bao-cao/video",
  "/kol/reports/province-summary": "/kol/bao-cao/tong-hop-tinh",
  "/kol/reports/all-videos": "/kol/bao-cao/tat-ca-video",
  "/kol/reports/campaign-perf": "/kol/bao-cao/hieu-qua-dot",
  "/kol/reports/tong-quan": "/kol/bao-cao/tong-quan",
  "/kol/reports/tinh-thanh": "/kol/bao-cao/tinh-thanh",
  "/kol/reports/ke-hoach-ngan-sach": "/kol/bao-cao/ke-hoach-ngan-sach",
};

/** Trang rieng cu cua ke hoach hang hoa → tab cua trang Ke hoach hang hoa (giu bo loc tren query). */
function KeHoachTabRedirect({ tab }: { tab: string }) {
  const { search } = useLocation();
  return <Navigate to={`/nhanhvn/ke-hoach-hang-hoa/${tab}${search}`} replace />;
}

function LegacyKolCampaignRedirect() {
  const { pk = "" } = useParams();
  return <Navigate to={`/kol/chien-dich/${pk}`} replace />;
}

function LegacyThhtDetailRedirect() {
  const { requestCode = "" } = useParams();
  return (
    <Navigate
      to={`/thht/list?detail=${encodeURIComponent(requestCode)}`}
      replace
    />
  );
}

function LegacyRoleEditPage() {
  const { id = "" } = useParams();
  return <RoleListPage initialRoleId={id} />;
}

function LegacyUserPermissionPage() {
  const { id = "" } = useParams();
  return <UserPermissionPage initialUserId={id} />;
}

/**
 * Bo dinh tuyen cua stack TS.
 *
 * Khai bao toan bo duong dan cua giao dien TypeScript. Gateway chi tach rieng
 * prefix /cleaning cho Checklist; duong dan khong khop se vao trang 404 React.
 *
 *   /login      dang nhap cua he thong (co the cap them phien Checklist)
 *   /apps       cong ung dung
 *   /cashflow   doi soat dong tien
 */
export function App() {
  const location = useLocation();
  // Bo giao dien theo tai khoan: <html data-ui-theme> theo app cua trang dang xem.
  useUiTheme(location.pathname);

  // Trang dang nhap va cong ung dung khong co sidebar cua module.
  if (location.pathname.startsWith("/login")) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
      </Routes>
    );
  }

  // Bookmark cu cua Django: /logout/ phai dang xuat that; /403/?feature= la trang tu choi quyen.
  if (/^\/(logout|403)(\/|$)/.test(location.pathname)) {
    return (
      <Routes>
        <Route path="/logout/*" element={<LogoutPage />} />
        <Route path="/403/*" element={<ForbiddenPage />} />
      </Routes>
    );
  }

  // Checklist: trang nhan vien / quet QR / anh QR dung tren dien thoai, khong sidebar.
  if (CLEANING_STANDALONE_RE.test(location.pathname)) {
    return <CleaningStandalone />;
  }

  if (location.pathname.startsWith("/apps")) {
    return (
      <Routes>
        <Route path="/apps" element={<PortalPage />} />
      </Routes>
    );
  }

  // Ho so ca nhan khong thuoc module nao nen cung khong co sidebar module.
  // Hai URL tieng Anh la bookmark cua Django cu, deu dua ve cung trang moi.
  if (
    location.pathname.startsWith("/ho-so") ||
    location.pathname.startsWith("/cai-dat/giao-dien") ||
    location.pathname.startsWith("/profile") ||
    location.pathname.startsWith("/change-password")
  ) {
    return (
      <Routes>
        <Route path="/ho-so" element={<ProfilePage />} />
        <Route path="/cai-dat/giao-dien" element={<UiSettingsPage />} />
        <Route path="/profile" element={<Navigate to="/ho-so" replace />} />
        <Route
          path="/change-password"
          element={<Navigate to="/ho-so" replace />}
        />
      </Routes>
    );
  }

  // Công khai cho nhân viên kho, không dùng sidebar và không yêu cầu đăng nhập.
  if (location.pathname.startsWith("/nhanhvn/tra-cuu-bao")) {
    return (
      <Routes>
        <Route path="/nhanhvn/tra-cuu-bao" element={<BagLookupPage />} />
      </Routes>
    );
  }

  if (
    location.pathname.startsWith("/voucher/register") ||
    location.pathname.startsWith("/voucher/claim") ||
    location.pathname.startsWith("/voucher/success")
  ) {
    return (
      <Routes>
        <Route
          path="/voucher/register/success/:resultId"
          element={<VoucherPublicResultPage mode="register" />}
        />
        <Route
          path="/voucher/success/:resultId"
          element={<VoucherPublicResultPage mode="claim" />}
        />
        <Route
          path="/voucher/register/:campaignId?"
          element={<VoucherPublicPage mode="register" />}
        />
        <Route
          path="/voucher/claim/:campaignId"
          element={<VoucherPublicPage mode="claim" />}
        />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        path="/tmdt"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tmdt">
            <TmdtHomePage />
          </ModuleLayout>
        }
      />
      <Route
        path="/cashflow"
        element={
          <ModuleLayout moduleKey="cashflow" activeHref="/cashflow">
            <TransactionListPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/cashflow/monthly"
        element={
          <ModuleLayout moduleKey="cashflow" activeHref="/cashflow/monthly">
            <MonthlySummaryPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/cashflow/bank-history"
        element={
          <ModuleLayout
            moduleKey="cashflow"
            activeHref="/cashflow/bank-history"
          >
            <BankHistoryPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/cashflow/revenue"
        element={
          <ModuleLayout moduleKey="cashflow" activeHref="/cashflow/revenue">
            <DailyRevenuePage />
          </ModuleLayout>
        }
      />
      <Route
        path="/cashflow/revenue/store"
        element={
          <ModuleLayout
            moduleKey="cashflow"
            activeHref="/cashflow/revenue/store"
          >
            <StoreRevenuePage />
          </ModuleLayout>
        }
      />
      <Route
        path="/cash-qr"
        element={
          <ModuleLayout moduleKey="cash_qr" activeHref="/cash-qr">
            <StoreCashQrPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/cash-qr/deposits"
        element={
          <ModuleLayout moduleKey="cash_qr" activeHref="/cash-qr/deposits">
            <CashDepositsPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/cash-qr/mapping"
        element={
          <ModuleLayout moduleKey="cash_qr" activeHref="/cash-qr/mapping">
            <MappingPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/hr"
        element={
          <ModuleLayout moduleKey="hr" activeHref="/hr">
            <EmployeeListPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/hr/accounts"
        element={
          <ModuleLayout moduleKey="hr" activeHref="/hr/accounts">
            <AccountListPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/hr/:id"
        element={
          <ModuleLayout moduleKey="hr" activeHref="/hr">
            <EmployeeDetailPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/auditlog"
        element={
          <ModuleLayout moduleKey="auditlog" activeHref="/auditlog">
            <AuditLogPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/rbac/users"
        element={
          <ModuleLayout moduleKey="hr" activeHref="/rbac/users">
            <UserPermissionPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/rbac/users/:id"
        element={
          <ModuleLayout moduleKey="hr" activeHref="/rbac/users">
            <LegacyUserPermissionPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/rbac/roles"
        element={
          <ModuleLayout moduleKey="hr" activeHref="/rbac/roles">
            <RoleListPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/rbac/roles/create"
        element={
          <ModuleLayout moduleKey="hr" activeHref="/rbac/roles">
            <RoleListPage initialRoleId="new" />
          </ModuleLayout>
        }
      />
      <Route
        path="/rbac/roles/:id/edit"
        element={
          <ModuleLayout moduleKey="hr" activeHref="/rbac/roles">
            <LegacyRoleEditPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/moh"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/moh">
            <MohReportPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/moh-gia-tri"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/moh-gia-tri">
            <MohValuePage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/ban-chay"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/ban-chay">
            <BestsellerPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/phan-tich-sp"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/phan-tich-sp">
            <ProductAnalyticsPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/phan-tich-kh"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/phan-tich-kh">
            <CustomerAnalyticsPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/dashboard-hang-hoa"
        element={
          <ModuleLayout
            moduleKey="nhanhvn"
            activeHref="/nhanhvn/dashboard-hang-hoa"
          >
            <ProductionDashboardPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/ban-hang"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/ban-hang">
            <SalesPivotPage kind="ban-hang" />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/don-hang"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/don-hang">
            <SalesPivotPage kind="don-hang" />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/theo-thang"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/theo-thang">
            <MonthlyReportPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/chi-tiet-sp"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/chi-tiet-sp">
            <MonthlyProductPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/danh-sach-bill"
        element={
          <ModuleLayout
            moduleKey="nhanhvn"
            activeHref="/nhanhvn/danh-sach-bill"
          >
            <BillListPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/cau-hinh-sp"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/cau-hinh-sp">
            <ProductConfigPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/tai-ma"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/tai-ma">
            <ProductRecodePage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/ngay-ban-dau-tien"
        element={
          <ModuleLayout
            moduleKey="nhanhvn"
            activeHref="/nhanhvn/ngay-ban-dau-tien"
          >
            <FirstSalePage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/chia-hang"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/chia-hang">
            <AllocationPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/chia-hang-dt"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/chia-hang-dt">
            <ShopeeAllocPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/chia-hang-nhap"
        element={
          <ModuleLayout
            moduleKey="nhanhvn"
            activeHref="/nhanhvn/chia-hang-nhap"
          >
            <ImportAllocPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/phieu-nhap"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/phieu-nhap">
            <ImportReceiptsPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/chia-kho-mt"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/chia-kho-mt">
            <MtTransferPage scope="mt" />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/chia-kho-cua-hang"
        element={
          <ModuleLayout
            moduleKey="nhanhvn"
            activeHref="/nhanhvn/chia-kho-cua-hang"
          >
            <MtTransferPage scope="khoch" />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/target-v3"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/target-v3">
            <TargetV3Page />
          </ModuleLayout>
        }
      />
      <Route
        path="/cskh"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/cskh">
            <CskhDashboardPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/cskh/kpi"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/cskh/kpi">
            <CskhKpiPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/cskh/lich-truc"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/cskh/lich-truc">
            <CskhOperationsPage mode="schedule" />
          </ModuleLayout>
        }
      />
      <Route
        path="/cskh/hoi-thoai"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/cskh/hoi-thoai">
            <CskhOperationsPage mode="conversations" />
          </ModuleLayout>
        }
      />
      <Route
        path="/cskh/quan-ly"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/cskh/quan-ly">
            <CskhOperationsPage mode="manage" />
          </ModuleLayout>
        }
      />
      <Route
        path="/cskh/schedule"
        element={<Navigate to="/cskh/lich-truc" replace />}
      />
      <Route
        path="/cskh/conversations"
        element={<Navigate to="/cskh/hoi-thoai" replace />}
      />
      <Route
        path="/cskh/accounts"
        element={<Navigate to="/cskh/quan-ly?tab=accounts" replace />}
      />
      <Route
        path="/cskh/violation-types"
        element={<Navigate to="/cskh/quan-ly?tab=types" replace />}
      />
      <Route
        path="/cskh/violations"
        element={<Navigate to="/cskh/quan-ly" replace />}
      />
      <Route
        path="/thht"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/thht">
            <ThhtDashboardPage />
          </ModuleLayout>
        }
      />
      {/* Trang ghi can la trang RIENG cho dien thoai ghep may quet (nhu ban Django): khong
          menu trai — nhan vien DVVC chi can o ma, o can va nut luu. */}
      <Route
        path="/can-nang"
        element={
          <RequirePermission
            anyOf={["portal.shipping_weight", "shipping_weight.*"]}
            feature="Cân nặng vận đơn"
          >
            <ShippingWeightPage />
          </RequirePermission>
        }
      />
      <Route
        path="/voucher"
        element={
          <ModuleLayout moduleKey="voucher" activeHref="/voucher">
            <VoucherPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok">
            <TiktokPage view="overview" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/reviews"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok/reviews">
            <TiktokPage view="reviews" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/statistics"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok/statistics">
            <TiktokPage view="review-stats" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/tracking"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok/tracking">
            <TiktokPage view="review-tracking" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/reviews/statistics/employees"
        element={
          <ModuleLayout
            moduleKey="tmdt"
            activeHref="/tiktok/reviews/statistics/employees"
          >
            <TiktokPage view="review-employees" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/reviews/statistics/employees/:id/detail"
        element={
          <ModuleLayout
            moduleKey="tmdt"
            activeHref="/tiktok/reviews/statistics/employees"
          >
            <TiktokPage view="review-employees" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/live/dashboard"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok/live/dashboard">
            <TiktokPage view="live" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/live/analysis"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok/live/analysis">
            <TiktokPage view="live-analysis" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/salary/report"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok/salary/report">
            <TiktokPage view="salary" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/salary/detail/:id"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok/salary/report">
            <TiktokPage view="salary-detail" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/salary/violation-types"
        element={
          <ModuleLayout
            moduleKey="tmdt"
            activeHref="/tiktok/salary/violation-types"
          >
            <TiktokPage view="violation-types" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/shop/orders"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok/shop/orders">
            <TiktokPage view="orders" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/shop/orders/:orderId"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok/shop/orders">
            <TiktokPage view="order-detail" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/shop/products"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok/shop/products">
            <TiktokPage view="products" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/shop/vi-pham"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok/shop/vi-pham">
            <TiktokPage view="product-violations" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/shop/revenue"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok/shop/revenue">
            <TiktokPage view="revenue" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/shop/callback"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok">
            <TiktokPage view="callback" />
          </ModuleLayout>
        }
      />
      <Route path="/dashboard" element={<Navigate to="/ho-so" replace />} />
      <Route
        path="/tiktok/stats"
        element={<Navigate to="/tiktok/statistics" replace />}
      />
      <Route
        path="/tiktok/live/reports"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/tiktok/live/analysis">
            <TiktokPage view="live-reports" />
          </ModuleLayout>
        }
      />
      <Route
        path="/tiktok/shop/auth"
        element={<Navigate to="/tiktok" replace />}
      />
      <Route
        path="/voucher/campaigns"
        element={
          <ModuleLayout moduleKey="voucher" activeHref="/voucher/campaigns">
            <VoucherPage view="campaigns" />
          </ModuleLayout>
        }
      />
      <Route
        path="/voucher/campaigns/:campaignId"
        element={
          <ModuleLayout moduleKey="voucher" activeHref="/voucher/campaigns">
            <VoucherCampaignDetailPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/voucher/registrations"
        element={
          <ModuleLayout moduleKey="voucher" activeHref="/voucher/registrations">
            <VoucherPage view="registrations" />
          </ModuleLayout>
        }
      />
      <Route
        path="/voucher/issue"
        element={<Navigate to="/voucher" replace />}
      />
      <Route
        path="/voucher/nhanh-campaigns"
        element={<Navigate to="/voucher/campaigns" replace />}
      />
      <Route
        path="/can-nang/bao-cao"
        element={
          <ModuleLayout
            moduleKey="shipping_weight"
            activeHref="/can-nang/bao-cao"
          >
            <ShippingWeightPage mode="report" />
          </ModuleLayout>
        }
      />
      <Route
        path="/thht/list"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/thht/list">
            <ThhtListPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/thht/report"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/thht/report">
            <ThhtReportPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/thht/detail/:requestCode"
        element={<LegacyThhtDetailRedirect />}
      />
      {/* KOL/KOC — trang, API va Playwright crawler deu chay trong stack TS. */}
      <Route
        path="/kol/danh-sach-koc"
        element={
          <ModuleLayout moduleKey="kol" activeHref="/kol/danh-sach-koc">
            <KolKocListPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/kol/chien-dich"
        element={
          <ModuleLayout moduleKey="kol" activeHref="/kol/chien-dich">
            <KolCampaignListPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/kol/chien-dich/:pk"
        element={
          <ModuleLayout moduleKey="kol" activeHref="/kol/chien-dich">
            <KolCampaignDetailPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/kol/bao-cao/tong-quan"
        element={
          <ModuleLayout moduleKey="kol" activeHref="/kol/bao-cao/tong-quan">
            <KolCampaignPerformancePage key="overview" page="overview" />
          </ModuleLayout>
        }
      />
      <Route
        path="/kol/bao-cao/hieu-qua-dot"
        element={
          <ModuleLayout moduleKey="kol" activeHref="/kol/bao-cao/hieu-qua-dot">
            <KolCampaignPerformancePage />
          </ModuleLayout>
        }
      />
      <Route
        path="/kol/bao-cao/tinh-thanh"
        element={
          <ModuleLayout moduleKey="kol" activeHref="/kol/bao-cao/tinh-thanh">
            <KolCampaignPerformancePage key="province" page="province" />
          </ModuleLayout>
        }
      />
      <Route
        path="/kol/bao-cao/ke-hoach-ngan-sach"
        element={
          <ModuleLayout
            moduleKey="kol"
            activeHref="/kol/bao-cao/ke-hoach-ngan-sach"
          >
            <KolCampaignPerformancePage key="plan" page="plan" />
          </ModuleLayout>
        }
      />
      <Route
        path="/kol/bao-cao/koc"
        element={
          <ModuleLayout moduleKey="kol" activeHref="/kol/bao-cao/koc">
            <KolReportKocPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/kol/bao-cao/koc-theo-ngay"
        element={
          <ModuleLayout moduleKey="kol" activeHref="/kol/bao-cao/koc-theo-ngay">
            <KolReportDailyPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/kol/bao-cao/dang-muon"
        element={
          <ModuleLayout moduleKey="kol" activeHref="/kol/bao-cao/dang-muon">
            <KolReportLatePostPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/kol/bao-cao/chi-phi"
        element={
          <ModuleLayout moduleKey="kol" activeHref="/kol/bao-cao/chi-phi">
            <KolReportCostPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/kol/bao-cao/video"
        element={
          <ModuleLayout moduleKey="kol" activeHref="/kol/bao-cao/video">
            <KolReportVideoPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/kol/bao-cao/tat-ca-video"
        element={
          <ModuleLayout moduleKey="kol" activeHref="/kol/bao-cao/tat-ca-video">
            <KolReportAllVideosPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/kol/bao-cao/tong-hop-tinh"
        element={
          <ModuleLayout moduleKey="kol" activeHref="/kol/bao-cao/tong-hop-tinh">
            <KolProvinceSummaryPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/facebook"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/facebook">
            <FacebookPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/facebook/report"
        element={<Navigate to="/facebook" replace />}
      />
      <Route
        path="/cskh/monthly-kpi"
        element={<Navigate to="/cskh/kpi" replace />}
      />
      {/* URL cu cua Django: truoc day roi ve /apps thay vi trang tuong ung. */}
      <Route
        path="/shifts/register"
        element={<Navigate to="/shifts" replace />}
      />
      <Route
        path="/cashflow/revenue/store-summary"
        element={<Navigate to="/cashflow/revenue/store" replace />}
      />
      <Route
        path="/facebook/sync"
        element={<Navigate to="/facebook" replace />}
      />
      <Route
        path="/shifts"
        element={
          <ModuleLayout moduleKey="tmdt" activeHref="/shifts">
            <ShiftCalendarPage />
          </ModuleLayout>
        }
      />
      {/* Trang "Tự đăng ký ca" da bo (23/10/2026) — link cu ve lich thang. */}
      <Route
        path="/shifts/dang-ky"
        element={<Navigate to="/shifts" replace />}
      />
      <Route
        path="/nhanhvn/theo-doi-sx"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/theo-doi-sx">
            <ProductionLarkPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/dat-hang-tq"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/dat-hang-tq">
            <ChinaOrderPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/bu-hang"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/bu-hang">
            <RestockPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/target-danh-muc"
        element={
          <ModuleLayout
            moduleKey="nhanhvn"
            activeHref="/nhanhvn/target-danh-muc"
          >
            <TargetCategoryPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/san-luong-sx"
        element={
          <ModuleLayout moduleKey="nhanhvn" activeHref="/nhanhvn/san-luong-sx">
            <ProductionDetailPage />
          </ModuleLayout>
        }
      />
      {/* Ke hoach hang hoa: MOT trang nhieu tab (nhu ban demo); trang rieng cu chuyen ve tab. */}
      <Route
        path="/nhanhvn/ke-hoach-hang-hoa/:tab?"
        element={
          <ModuleLayout
            moduleKey="nhanhvn"
            activeHref="/nhanhvn/ke-hoach-hang-hoa"
          >
            <KeHoachHangHoaPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/nhanhvn/ke-hoach-nhap"
        element={<KeHoachTabRedirect tab="nhap-hang" />}
      />
      <Route
        path="/nhanhvn/dieu-phoi"
        element={<KeHoachTabRedirect tab="dieu-phoi" />}
      />
      <Route
        path="/nhanhvn/dang-ve"
        element={<KeHoachTabRedirect tab="dang-ve" />}
      />
      <Route
        path="/nhanhvn/tong-quan-ke-hoach"
        element={<KeHoachTabRedirect tab="tong-quan" />}
      />
      <Route
        path="/nhanhvn/ti-trong-vung"
        element={<KeHoachTabRedirect tab="ti-trong-vung" />}
      />
      <Route
        path="/nhanhvn/bo-khai-truong"
        element={<KeHoachTabRedirect tab="bo-khai-truong" />}
      />
      <Route
        path="/disbursement"
        element={
          <ModuleLayout moduleKey="disbursement" activeHref="/disbursement">
            <PlanListPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/disbursement/periods"
        element={
          <ModuleLayout
            moduleKey="disbursement"
            activeHref="/disbursement/periods"
          >
            <InterestPeriodsPage />
          </ModuleLayout>
        }
      />
      <Route
        path="/disbursement/bank-config"
        element={
          <ModuleLayout
            moduleKey="disbursement"
            activeHref="/disbursement/bank-config"
          >
            <BankConfigPage />
          </ModuleLayout>
        }
      />
      {/* Dat SAU hai duong dan co dinh o tren: '/disbursement/periods' phai la
          trang lich, khong duoc hieu thanh mot khoan vay ten 'periods'. */}
      <Route
        path="/disbursement/:id"
        element={
          <ModuleLayout moduleKey="disbursement" activeHref="/disbursement">
            <PlanDetailPage />
          </ModuleLayout>
        }
      />
      {/* Vao thang '/' thi ve cong ung dung, khong nhay vao mot module cu the:
          nguoi dung tu chon app la thoi quen cua ban cu. */}
      <Route path="/" element={<Navigate to="/apps" replace />} />
      {/* Cua vao theo quyen nhu `app_entry` cua Django (ban-hang / phan-tich-kh). */}
      <Route path="/nhanhvn" element={<NhanhvnEntry />} />
      <Route path="/kol" element={<Navigate to="/kol/chien-dich" replace />} />
      {/* Quan tri du lieu tong quat, thay `/admin/` cua Django (chi superuser —
          may chu tu choi nguoi khac, giao dien chi hien loi 403). */}
      {/* Quan tri du lieu: API chi cho superuser (SuperuserGuard). */}
      <Route
        path="/admin"
        element={
          <RequirePermission superuserOnly feature="Quản trị dữ liệu">
            <AdminIndexPage />
          </RequirePermission>
        }
      />
      <Route
        path="/admin/:model"
        element={
          <RequirePermission superuserOnly feature="Quản trị dữ liệu">
            <AdminModelPage />
          </RequirePermission>
        }
      />
      <Route
        path="/admin/:model/:id"
        element={
          <RequirePermission superuserOnly feature="Quản trị dữ liệu">
            <AdminRowPage />
          </RequirePermission>
        }
      />
      <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
      {Object.entries(LEGACY_NHANHVN_ROUTES).map(([from, to]) => (
        <Route key={from} path={from} element={<Navigate to={to} replace />} />
      ))}
      {Object.entries(LEGACY_KOL_ROUTES).map(([from, to]) => (
        <Route key={from} path={from} element={<Navigate to={to} replace />} />
      ))}
      <Route
        path="/kol/campaigns/:pk"
        element={<LegacyKolCampaignRedirect />}
      />
      {cleaningRoutes()}
      <Route path="*" element={<Navigate to="/apps" replace />} />
    </Routes>
  );
}
